export const SysParamsStore = {
  namespaced: true,
  state: {
    sysParams: []
  },
  actions: {
    async refreshSysParams({ commit }, action) {
      commit("setSysParams", action.payload);
    }
  },
  getters: {
    sysParams: state => {
      return state.sysParams;
    }
  },
  mutations: {
    setSysParams(state, payload) {
      state.sysParams = payload;
      //LocalStorageService.setSysMenu(payload);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/global/SysParamsStore/SysParamsStore.js